/* global Ad */
const CompareList = {
    onRemove: () => {},
    onAdd: () => {},

    init(options) {
        const self = this;

        self.onRemove = options.onRemove ? options.onRemove : () => {};
        self.onAdd = options.onAdd ? options.onAdd : () => {};

        initDatepickers();
        initSubmit();
        initRemoveAll();
        initRemove();
    },

    update(options) {
        const self = this;
        updateCompareForm(options.removed, options.unitId, self.onRemove);
    },
};

const selectors = {
    form: '#form_compare',
    $compareSidebarBox: $('#compareBox'),
    $loader: $('#compareListLoader'),
};

function initDatepickers() {
    if ($(selectors.form).length) {
        Ad.Datepicker.initRange('#compareForm_date_from', '#compareForm_date_to', {
            currentText: $('#datePickerData').data('today-text'),
        });
    }
}

function updateCompareForm(removed = false, unitId, onRemove) {
    if (selectors.$compareSidebarBox.length > 0) {
        selectors.$loader.show();

        $.ajax({
            url: selectors.$compareSidebarBox.data('compare-list-url'),
            type: 'GET',
        }).then((data) => {
            selectors.$compareSidebarBox.html(data);
            selectors.$loader.hide();
            initDatepickers();
        }).then(() => {
            const count = parseInt($('#form_compare').data('units-count'), 10);

            if (removed) {
                onRemove(unitId, count);
            }
        });
    }
}

function initSubmit() {
    $(document).on('click', '#compareOnFavoritesBtn', (event) => {
        event.preventDefault();

        selectors.$loader.show();
        $.ajax({
            url: selectors.$compareSidebarBox.data('compare-list-url'),
            type: 'POST',
            data: $(selectors.form).serialize(),
        }).then((data) => {
            selectors.$loader.hide();
            if (data.urlToComparePage) {
                selectors.$loader.show();
                window.location.href = data.urlToComparePage;
            } else {
                selectors.$compareSidebarBox.html(data);
            }
        });
    });
}

function initRemoveAll() {
    $(document).on('click', '.clearCompare', () => {
        $.ajax({
            url: $('.clearCompare').data('remove-all-url'),
        }).then(() => {
            window.location.reload();
        });
    });
}

function initRemove() {
    $(document).on('click', '.removeFromCompareList', function removeFromCompared() {
        const unitId = $(this).data('unit-id');
        const remove = $.post($('.compareList').data('remove-url'), { unitId });
        remove.done(() => {
            CompareList.update({ removed: true, unitId });
        });
    });
}

export default CompareList;
